module.exports = "<router-outlet style=\"height: 100%;\"></router-outlet>\n\n"